import React, { useState } from 'react';
import ToolLayout from './layout/ToolLayout';
import Card, { CardHeader } from './ui/Card';
import Button from './ui/Button';
import CopyButton from './ui/CopyButton';
import FormField from './ui/FormField';

const GuidGenerator = () => {
  const [generatedGuids, setGeneratedGuids] = useState([]);
  const [useUppercase, setUseUppercase] = useState(false);
  const [useBraces, setUseBraces] = useState(false);
  const [guidsAmount, setGuidsAmount] = useState(3);

  const generateGuid = () => {
    const generateSingleGuid = () => {
      const pattern = useBraces ? '{xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx}' : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      const guid = pattern.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });

      return useUppercase ? guid.toUpperCase() : guid;
    };

    setGeneratedGuids(Array.from({ length: guidsAmount }, generateSingleGuid));
  };

  return (
    <ToolLayout
      title="UUID Generator"
      description="Gere identificadores para testes, mocks e integrações mantendo o formato previsível."
      category="Security & Identity"
      note="Formato UUID v4"
    >
      <div className="tool-grid tool-grid--tool-page">
        <Card>
          <CardHeader title="Parâmetros" description="Escolha o formato de saída e o volume desejado." />
          <FormField label="Quantidade">
            <input className="app-input" type="number" min="1" value={guidsAmount} onChange={(e) => setGuidsAmount(Math.max(1, parseInt(e.target.value, 10) || 1))} />
          </FormField>
          <div className="checkbox-grid">
            <label className="app-checkbox"><input type="checkbox" checked={useUppercase} onChange={() => setUseUppercase(!useUppercase)} /> <span>Uppercase</span></label>
            <label className="app-checkbox"><input type="checkbox" checked={useBraces} onChange={() => setUseBraces(!useBraces)} /> <span>Com chaves</span></label>
          </div>
          <div className="tool-actions">
            <Button onClick={generateGuid}>Gerar UUIDs</Button>
          </div>
        </Card>

        <Card>
          <CardHeader title="Resultado" description="Saída pronta para copiar ou colar em testes." action={<CopyButton value={generatedGuids.join('\n')} label="Copiar UUIDs" />} />
          <div className="output-panel">
            <span className="output-panel__label">UUIDs gerados</span>
            <pre>{generatedGuids.length ? generatedGuids.join('\n') : 'Os UUIDs gerados aparecerão aqui.'}</pre>
          </div>
        </Card>
      </div>
    </ToolLayout>
  );
};

export default GuidGenerator;
